import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { ProductDao } from '@app/dao/product/product.dao';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { finalize, take } from 'rxjs';
import { toNumber, toStringOrUndefined } from '../../subscription-form.utils';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'insurance-garanties',
    templateUrl: './insurance-garanties.component.html',
    styleUrls: ['./insurance-garanties.component.scss'],
    standalone: false
})
export class InsuranceGarantiesComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  parameters;

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected productDao: ProductDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    const pledge = this.subscriptionFacade.getPledge();
    this.parameters = pledge?.parameters;
    this.subscriptionFacade.initForm(this, { ...this.parameters });
  }

  onSubmit() {
    const pledge = this.subscriptionFacade.getPledge();
    const params = this.products?.get('0')?.get('parameters')?.value;
    const productParams = pledge?.products?.[0]?.parameters;
    const devisId = productParams?.devisRecommandeId;

    if (pledge && params && devisId) {
      const body = {
        productId: pledge.products?.[0]?.productId,
        ownerId: pledge.owners?.[0]?.ownerId || pledge.owners?.[0]?.id,
        cotisation: toNumber(productParams?.monthlyPayment),
        cotisationPeriode: productParams?.cotisationPeriode,
        ...(toStringOrUndefined(params.commentaire) && { commentaire: params.commentaire }),
        ...(toNumber(params.hospitalisationHonorairesOptam) != null && { hospitalisationHonorairesOptam: toNumber(params.hospitalisationHonorairesOptam) }),
        ...(toNumber(params.hospitalisationHonorairesNonOptam) != null && { hospitalisationHonorairesNonOptam: toNumber(params.hospitalisationHonorairesNonOptam) }),
        ...(toNumber(params.hospitalisationChambreParticuliere) != null && { hospitalisationChambreParticuliere: toNumber(params.hospitalisationChambreParticuliere) }),
        ...(toStringOrUndefined(params.hospitalisationPrimeMaternite) && { hospitalisationPrimeMaternite: params.hospitalisationPrimeMaternite }),
        ...(toNumber(params.optiqueLunettes) != null && { optiqueLunettes: toNumber(params.optiqueLunettes) }),
        ...(toNumber(params.optiqueLentilles) != null && { optiqueLentilles: toNumber(params.optiqueLentilles) }),
        ...(toNumber(params.optiquePlafond) != null && { optiquePlafond: toNumber(params.optiquePlafond) }),
        ...(toNumber(params.optiqueChirurgieLaser) != null && { optiqueChirurgieLaser: toNumber(params.optiqueChirurgieLaser) }),
        ...(toNumber(params.dentaireProthese) != null && { dentaireProthese: toNumber(params.dentaireProthese) }),
        ...(toStringOrUndefined(params.dentaireOrthodontieAdulte) && { dentaireOrthodontieAdulte: params.dentaireOrthodontieAdulte }),
        ...(toStringOrUndefined(params.dentaireOrthodontieEnfant) && { dentaireOrthodontieEnfant: params.dentaireOrthodontieEnfant }),
        ...(toNumber(params.pharmaciePriseEnCharge) != null && { pharmaciePriseEnCharge: toNumber(params.pharmaciePriseEnCharge) }),
        ...(toStringOrUndefined(params.medecinesDouces) && { medecinesDouces: params.medecinesDouces }),
        ...(toNumber(params.consultationsOptamCas) != null && { consultationsOptamCas: toNumber(params.consultationsOptamCas) }),
        ...(toNumber(params.consultationsNonOptamNonCas) != null && { consultationsNonOptamNonCas: toNumber(params.consultationsNonOptamNonCas) }),
        ...(toNumber(params.cotisationsMontant) != null && { cotisationsMontant: toNumber(params.cotisationsMontant) }),
      };
      // Sync devis puis soumission garantie APRÈS la persistance (succès ou échec)
      this.productDao.updateMutuelleDevis(Number(pledge.accountId), devisId, body)
        .pipe(
          take(1),
          finalize(() => this.subscriptionFacade.submitPledge(this)),
        )
        .subscribe({
          error: () =>
            this.notificationService.error(
              'La mise à jour du devis mutuelle a échoué',
            ),
        });
      return;
    }
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
